import { get, map, padStart, range } from 'lodash';

export const FormSelectDate = {
  bindings: {
    errors: '<',
    form: '<',
    name: '@',
    onUpdate: '&',
    required: '@',
    value: '<',
    yearStart: '<',
    yearNumber: '<',
  },

  template: `
    <div class="d-flex justify-content-center form-select-date">
      <select class="form-control"
        name="day"
        ng-model="$ctrl.day"
        ng-options="day for day in $ctrl.days"
        ng-change="$ctrl.onChange()">
        <option value="">Day</option>
      </select>
      <select class="form-control mx-2"
        name="month"
        ng-model="$ctrl.month"
        ng-options="(month | padStart:2:0) for month in $ctrl.months"
        ng-change="$ctrl.onChange()">
        <option value="">Month</option>
      </select>
      <select class="form-control"
        name="year"
        ng-model="$ctrl.year"
        ng-options="year for year in $ctrl.years"
        ng-change="$ctrl.onChange()">
        <option value="">Year</option>
      </select>
    </div>
    <input
      type="date"
      name="{{ $ctrl.name }}"
      ng-hide="true"
      ng-required="{{ $ctrl.required }}"
      ng-model="$ctrl.date"/>
    <form-errors field="$ctrl.form[$ctrl.name]" errors="$ctrl.errors"/>`,

  controller($timeout) {
    'ngInject';

    const padLeft0 = value => {
      return padStart(value, 2, 0);
    };

    const getDate = value => {
      return new Date(Date.parse(value));
    };

    return {
      $onInit() {
        const year = new Date().getFullYear() + (this.yearStart || 0);
        this.days = map(range(1, 32), padLeft0);
        this.months = map(range(1, 13), padLeft0);
        this.years = range(year, year - (this.yearNumber || 0));
      },

      $onChanges(changes) {
        const value = get(changes, 'value.currentValue');

        if (value) {
          this.date = getDate(value);
          this.day = padLeft0(this.date.getDate());
          this.month = padLeft0(this.date.getMonth() + 1);
          this.year = this.date.getFullYear();
        }
      },

      onChange() {
        const { day, year, month } = this;
        const field = this.form[this.name];

        if (!day || !year || !month) {
          field.$setTouched();
          field.$setValidity('required', !!(day || month || year));
          field.$setValidity('date', false);
        } else {
          this.date = getDate(`${year}-${month}-${day}`);

          $timeout(() => {
            if (field.$valid) {
              this.onUpdate({ key: this.name, value: field.$viewValue });
            }
          });
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/FormElements/FormSelectDate.js